import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Canonical host enforcement: redirect www.traindriverfoundation.com → traindriverfoundation.com
// before React renders. This is a code-level fallback while awaiting server/edge-level 301 redirect.
// Preserves protocol (https), pathname, query string, and hash.
if (typeof window !== "undefined" && window.location.hostname === "www.traindriverfoundation.com") {
  const target = new URL(window.location.href);
  target.protocol = "https:";
  target.hostname = "traindriverfoundation.com";
  window.location.replace(target.toString());
}

const container = document.getElementById("root");

// Detect the bot-only static fallback content injected into index.html and
// the per-route stubs by scripts/prerender-routes.js. We strip it before
// mounting React, otherwise hydration would mismatch (the static content is
// intentionally *different* from what the SPA renders — it's a crawler-only
// summary, not a true SSR snapshot of every component). createRoot then
// mounts the real app cleanly. Users never see the fallback.
if (container && container.firstElementChild) {
  container.innerHTML = "";
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
